import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BlockedCprService } from '../../services/blocked-cpr.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-blocked-cpr-list',
  templateUrl: './blocked-cpr-list.component.html',
  styleUrls: ['./blocked-cpr-list.component.scss']
})
export class BlockedCprListComponent implements OnInit {
  blockedCprs: any[] = [];
  searchForm: FormGroup;
  currentPage = 1;
  totalPages = 1;
  totalItems = 0;
  itemsPerPage = 10;
  searchTerms = new Subject<string>();
  loading = false;

  constructor(
    private blockedCprService: BlockedCprService,
    private fb: FormBuilder
  ) {
    this.searchForm = this.fb.group({
      search: ['']
    });
  }

  ngOnInit(): void {
    this.searchTerms.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(term => {
      this.currentPage = 1;
      this.loadBlockedCprs(term);
    });

    this.loadBlockedCprs();
  }

  loadBlockedCprs(search: string = ''): void {
    this.loading = true;
    this.blockedCprService.getBlockedCprList(this.currentPage, this.itemsPerPage, search)
      .subscribe(
        response => {
          if (response.status) {
            this.blockedCprs = response.data.blockedCprs;
            this.totalItems = response.data.total;
            this.totalPages = response.data.pages;
          } else {
            this.blockedCprs = [];
            this.totalItems = 0;
            this.totalPages = 1;
          }
          this.loading = false;
        },
        error => {
          console.error('Error loading blocked CPRs:', error);
          this.blockedCprs = [];
          this.loading = false;
        }
      );
  }

  onSearch(): void {
    const term = this.searchForm.get('search')?.value;
    this.searchTerms.next(term);
  }

  changePage(page: number): void {
    if (page !== this.currentPage && page > 0 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadBlockedCprs(this.searchForm.get('search')?.value || '');
    }
  }

  deleteBlockedCpr(id: string): void {
    if (confirm('Are you sure you want to delete this blocked CPR number?')) {
      this.blockedCprService.deleteBlockedCpr(id)
        .subscribe(
          response => {
            if (response.status) {
              // Reload the list after successful deletion
              this.loadBlockedCprs(this.searchForm.get('search')?.value || '');
            }
          },
          error => {
            console.error('Error deleting blocked CPR:', error);
          }
        );
    }
  }

  getPages(): number[] {
    const pages: number[] = [];
    const startPage = Math.max(1, this.currentPage - 2);
    const endPage = Math.min(this.totalPages, startPage + 4);
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }
} 